<template>
  <div class="pe-orchestrator-container">
    <slot></slot>
  </div>
</template>

<style scoped>
.pe-orchestrator-container {
  width: var(--pe-or-container-width, 100%);
  margin: var(--pe-or-container-mg, 0 auto);
  background: var(--pe-or-container-bg, transparent);

  display: flex;
  flex-direction: column;
  gap: var(--pe-or-container-gp, 3vh);
}
</style>